export const arrayUnique = <T>(array: T[]) => array.filter((v: T, i: number, a: T[]) => a.indexOf(v) === i);